import {
  CREATE_EMAIL_TEMPLATE_SUCCESS,
  CREATE_MAIL_FOLDER_SUCCESS,
  CREATE_MAIL_GROUP_SUCCESS,
  CREATE_MAIL_SUCCESS,
  DELETE_EMAIL_TEMPLATE_SUCCESS,
  DELETE_MAIL_FOLDER_SUCCESS,
  DELETE_MAIL_GROUP_SUCCESS,
  DELETE_MAIL_SUCCESS,
  EDIT_MAIL_GROUP_SUCCESS,
  EDIT_MAIL_SUCCESS,
  EDIT_MAIL_TEMPLATE_SUCCESS,
  GET_ALL_MAIL_FOLDER_SUCCESS,
  GET_ALL_MAIL_GROUP_SUCCESS,
  GET_ALL_MAIL_SUCCESS,
  GET_EMAIL_TAMPLATE_DROPDOWN_SUCCESS,
  GET_EMAIL_TEMPLATE_SUCCESS,
  GET_MAIL_ID_SUCCESS,
  GET_NOT_READ_EMAILS_SUCCESS,
  RESET_MAILBOX_FILE,
  RESET_MAILBOX_FOLDER,
  RESET_MAIL_DETAILS,
  RESET_MAIL_GROUP_DETAILS,
  RESET_SINGLE_MAIL,
  SAVE_MAILBOX_FILE_ERROR,
  SAVE_MAILBOX_FILE_SUCCESS,
  SET_EMAIL_VALUE,
  SET_LOCAL_NEW_EMAIL,
  UPDATE_UNREAD_EMAIL_COUNT,
} from "../constants";
import { cloneDeep, remove, findIndex } from "lodash";

export const initialState = {
  mailDetails: undefined,
  mailFolder: undefined,
  singleMailDetails: undefined,
  currentEmailbox: undefined,
  attach_file: [],
  mailGroup: undefined,
  isReadMail: 0,
  emailTemplate: undefined,
  emailTemplateDropdown: undefined,
};
export const MailboxReducer = (state = initialState, action) => {
  //switch between action.type

  switch (action.type) {
    case GET_EMAIL_TEMPLATE_SUCCESS: {
      return {
        ...state,
        emailTemplate: action.payload,
      };
    }
    case GET_EMAIL_TAMPLATE_DROPDOWN_SUCCESS: {
      return {
        ...state,
        emailTemplateDropdown: action.payload,
      };
    }
    case CREATE_EMAIL_TEMPLATE_SUCCESS: {
      const temprAddDetails = cloneDeep(state.emailTemplate);
      temprAddDetails.data.splice(0, 0, action.payload);
      return {
        ...state,
        emailTemplate: temprAddDetails,
      };
    }
    case EDIT_MAIL_TEMPLATE_SUCCESS: {
      const tempMailDetails = cloneDeep(state.emailTemplate);
      const index = findIndex(
        tempMailDetails.data,
        (obj) => obj._id === action.payload._id
      );

      if (index !== -1) {
        tempMailDetails.data[index] = action.payload;
      }
      return {
        ...state,
        emailTemplate: tempMailDetails,
      };
    }
    case DELETE_EMAIL_TEMPLATE_SUCCESS: {
      const tempDeleteComm = cloneDeep(state.emailTemplate);
      remove(tempDeleteComm.data, (obj) => obj._id === action.payload);
      return {
        ...state,
        emailTemplate: tempDeleteComm,
      };
    }
    case GET_ALL_MAIL_SUCCESS:
      return {
        ...state,
        mailDetails: action.payload,
      };
    case CREATE_MAIL_SUCCESS: {
      const temprAddDetails = cloneDeep(state.mailDetails);
      temprAddDetails.data.splice(0, 0, action.payload);
      return {
        ...state,
        mailDetails: temprAddDetails,
      };
    }
    case EDIT_MAIL_SUCCESS: {
      const tempMailDetails = cloneDeep(state.mailDetails);
      const index = findIndex(
        tempMailDetails.data,
        (obj) => obj._id === action.payload._id
      );

      if (index !== -1) {
        tempMailDetails.data[index] = action.payload;
      }
      return {
        ...state,
        mailDetails: tempMailDetails,
      };
    }
    case GET_ALL_MAIL_FOLDER_SUCCESS:
      return {
        ...state,
        mailFolder: action.payload,
      };

    case GET_NOT_READ_EMAILS_SUCCESS:
      return {
        ...state,
        isReadMail: action.payload,
      };
    case UPDATE_UNREAD_EMAIL_COUNT:
      return {
        ...state,
        isReadMail: state.isReadMail - 1,
      };

    case CREATE_MAIL_FOLDER_SUCCESS: {
      const temprAddDetails = cloneDeep(state.mailFolder);
      temprAddDetails.data.splice(0, 0, action.payload);
      return {
        ...state,
        mailFolder: temprAddDetails,
      };
    }

    case DELETE_MAIL_FOLDER_SUCCESS: {
      const tempDeleteComm = cloneDeep(state.mailFolder);
      remove(tempDeleteComm.data, (obj) => obj._id === action.payload);
      return {
        ...state,
        mailFolder: tempDeleteComm,
      };
    }
    case GET_MAIL_ID_SUCCESS:
      return {
        ...state,
        singleMailDetails: action.payload,
      };
    case RESET_SINGLE_MAIL: {
      return {
        ...state,
        singleMailDetails: "",
      };
    }
    case SET_LOCAL_NEW_EMAIL:
      return {
        ...state,
        currentEmailbox: action.payload,
      };
    case SET_EMAIL_VALUE: {
      const tempCurrentValue = cloneDeep(state.currentEmailbox);
      tempCurrentValue[action.payload.key] = action.payload.value;
      return {
        ...state,
        currentEmailbox: tempCurrentValue,
      };
    }
    case DELETE_MAIL_SUCCESS: {
      const tempDeleteComm = cloneDeep(state.mailDetails);
      remove(tempDeleteComm.data, (obj) => obj._id === action.payload);
      return {
        ...state,
        mailDetails: tempDeleteComm,
      };
    }
    case SAVE_MAILBOX_FILE_SUCCESS: {
      return {
        ...state,
        attach_file: [...state.attach_file, action.payload],
      };
    }
    case RESET_MAILBOX_FILE: {
      return {
        ...state,
        attach_file: [],
      };
    }
    case SAVE_MAILBOX_FILE_ERROR: {
      return {
        ...state,
        attach_file: [null],
      };
    }
    case RESET_MAIL_DETAILS: {
      return {
        ...state,
        mailDetails: "",
      };
    }
    case RESET_MAILBOX_FOLDER: {
      return {
        ...state,
        mailFolder: "",
      };
    }

    case GET_ALL_MAIL_GROUP_SUCCESS:
      return {
        ...state,
        mailGroup: action.payload,
      };
    case CREATE_MAIL_GROUP_SUCCESS:
      // const temprAddDetails = cloneDeep(state.mailGroup);
      // temprAddDetails.data.splice(0, 0, action.payload);
      // return {
      //   ...state,
      //   mailGroup: temprAddDetails,
      // };

      return {
        ...state,
        mailGroup: action.payload,
      };

    case EDIT_MAIL_GROUP_SUCCESS: {
      const tempCourseDetails = cloneDeep(state.mailGroup);
      const index = findIndex(
        tempCourseDetails.data,
        (obj) => obj._id === action.payload._id
      );

      if (index !== -1) {
        tempCourseDetails.data[index] = action.payload;
      }

      return {
        ...state,
        mailGroup: tempCourseDetails,
      };
    }
    case DELETE_MAIL_GROUP_SUCCESS: {
      const tempDeleteComm = cloneDeep(state.mailGroup);
      remove(tempDeleteComm.data, (obj) => obj._id === action.payload);
      return {
        ...state,
        mailGroup: tempDeleteComm,
      };
    }
    case RESET_MAIL_GROUP_DETAILS: {
      return {
        ...state,
        mailGroup: "",
      };
    }
    default:
      return state;
  }
};
